import { Input } from "@/components/ui/input";
import { taskActions } from '@common-reducers/TasksReducer';
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { namespace } from '@common/config/constants';
import { Search, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function SearchTasksShadcn({ boardType }: { boardType?: string }) {
    const { t } = useTranslation(namespace);
    const dispatch = useAppDispatch();
    const [searchQuery, setSearchQuery] = useState('');
    
    const textFilter = useAppSelector((state) => state.TasksReducer.tasksFilter.text);

    useEffect(() => {
        const nextQuery = textFilter instanceof RegExp ? textFilter.source : '';
        setSearchQuery(nextQuery);
    }, [textFilter]);

    function filterTasks(query: string) {
        dispatch(taskActions.setTasksFilterName(query));
        setSearchQuery(query);
    }

    const clearSearch = () => {
        dispatch(taskActions.setTasksFilterName(''));
        setSearchQuery('');
    };

    return (
        <div 
            className="relative w-full max-w-sm items-center opacity-50 hover:opacity-100 focus-within:opacity-100 transition-opacity"
            onMouseDown={(e) => e.stopPropagation()}
            onPointerDown={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
        >
            <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
            <Input
                type="text"
                placeholder={boardType === 'audience' ? t('searchTasks.searchAudience') : t('searchTasks.searchTasks')}
                value={searchQuery}
                onChange={(e) => filterTasks(e.target.value)}
                className="pl-9 pr-9 h-9 w-[200px] border-none shadow-none placeholder:text-gray-500"
            />
            {textFilter && (
                <button 
                    onClick={clearSearch}
                    className="absolute right-2.5 top-2.5 text-muted-foreground hover:text-foreground"
                >
                    <X className="h-4 w-4" />
                </button>
            )}
        </div>
    );
}
